import React, { useEffect, useState } from 'react';

interface IZeosModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const ZeosModal = ({ isOpen, onClose, children }: IZeosModalProps) => {
  const [active, setActive] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setActive(true);
      const timer = setTimeout(() => setAnimate(true), 10);
      return () => clearTimeout(timer);
    }
    setAnimate(false);
    const timer = setTimeout(() => setActive(false), 250);
    return () => clearTimeout(timer);
  }, [isOpen]);

  useEffect(() => {
    document.body.style.overflow = active ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [active]);

  const handleClose = () => {
    setActive(false);
    onClose();
  };

  if (active) {
    return (
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${
          animate ? "bg-black bg-opacity-50" : "bg-black bg-opacity-0"
        }`}
        onClick={handleClose}
      >
        <div
          className={`relative bg-white rounded-xl shadow-xl p-6 max-w-4xl w-full mx-4 transition-all duration-300 ${
            animate ? "opacity-100 scale-100" : "opacity-0 scale-95"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button in top right */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 text-xl hover:text-zeos-orange-dk"
          >
            &times;
          </button>
          {children}
        </div>
      </div>
    );
  } else {
    return null;
  }
};
